module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Package Types","couldNotFindAny":"Could not find package types"},"no":{"title":"Pakketype","couldNotFindAny":"Fant ikke pakketype"}}')
  delete Component.options._Ctor
}
